<template>
  <div class="modal-mask">
    <div class="popup" :class="[options.isFullscreen ? 'fullscreen' : null]">
      <div class="popup-title" v-html="options.dialog.title"></div>
      <div class="popup-body" v-if="options.dialog.body" v-html="options.dialog.body"></div>
      <VueQrcode class="popup-qr" v-if="options.valueQR" :value="options.valueQR" :options="{ width: 200 }" />
      <div class="popup-button" v-if="options.showButton">
        <a @click="action" href="javascript:;">
          <slot name="button">ไปที่แอป LINE</slot>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import VueQrcode from "@chenfengyuan/vue-qrcode"
export default {
  components: {
    VueQrcode
  },
  props: {
    options: {
      type: Object,
      default: {}
    },
    action: {
      type: Function
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.modal-mask {
  .popup {
    @extend %container-style;
    padding: 16px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
    width: 305px;
    height: 170px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 6px;
    text-align: center;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-align-content: center;
    align-content: center;
    .popup-title {
      @include finCol(12, 12, 0px, middle, true, true);
      @extend %font-size-m;
      color: $base-black;
      font-weight: bold;
    }
    .popup-body {
      @include finCol(12, 12, 0px, middle, true, true);
      @extend %font-size-ss;
      color: #949494;
    }
    .popup-qr {
      margin: auto;
    }
    .popup-button {
      @include finCol(12, 12, 0px, middle, true, true);
      a {
        @include finRippleBtn($color-green-line, $color-green-line, $color-white);
        @extend %font-size-m;
        width: 250px;
        margin-top: 18px;
        padding: 11px 25px;
        text-decoration: none;
        font-weight: bold;
        border-radius: 4px;
        display: inline-block;
      }
    }
  }
}
/* Transparent Overlay */
.modal-mask:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
.fullscreen {
  max-width: 100% !important;
  width: 100% !important;
  height: 100% !important;
}
</style>